/* eslint-disable import/prefer-default-export */
import { isDevelopmentEnv } from '@@/build/environment';

export function push(...args) {
  if (window.dataLayer && typeof window.dataLayer.push === 'function' && !isDevelopmentEnv()) {
    window.dataLayer.push(...args);
  }
}
